import {
	FETCH_FAHRER_BY_UUID,
	FETCH_FAHRER_SUCCESS } from '../actions/types';

export default function (state = [], action) {
	switch (action.type) {
		case FETCH_FAHRER_BY_UUID:
			console.log("action fetch_fahrer_by_uuid");
			return action.payload || false;
		case FETCH_FAHRER_SUCCESS:
			console.log("FETCH_FAHRER_SUCCESS");
			console.log("action.payload:", action.payload);
			return action.payload || [];
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/fahrerReducer.js